import store from 'store';
import * as actions from '../constants/actions';
import URLS from '../constants/urls';
import { getEnvironmentFromUrl } from './network';
const localStorageMiddleware = store => reduxStore => next => action => {
	if (action.type === actions.APP_INIT) {
	
		let payload = action.payload;

		const sitecode = store.get('sitecode');
		if (sitecode) {
			const params = action.payload && action.payload.params ?
				{
					...action.payload.params,
					sitecode
				} : { sitecode };
			payload = {
				...action.payload,
				params
			};
		}

		return next({
			...action,
			payload
		});
	} else if (action.type === actions.APP_STASH_QUERY_PARAMS) {
		store.set('previous_query_params', action.payload);
	} else if (action.type === actions.APP_CLEAR_STORED_QUERY_PARAMS ) {
		store.remove('previous_query_params');
	} else if (action.type === actions.APP_APPLY_STORED_QUERY_PARAMS ) {
		const prevQueryParams = store.get('previous_query_params');
		if(prevQueryParams) {
			const payload = {
				...action.payload,
				prevQueryParams
			};
			return next({
				...action,
				payload
			});
		}
	} else if (action.type === actions.FORM_INIT) {
		const sitecode = store.get('sitecode');
		if (sitecode) {
			const payload = {
				...action.payload,
				sitecode
			};
			return next({
				...action,
				payload
			});
		}
	} else if (action.type === actions.APP_AUTHENTICATED) {
		store.set('token_data', action.payload.accessToken);
		store.set('login_type', action.payload.loginType);

		if(action.payload.idToken != null){
			store.set('id_token', action.payload.idToken)
		}
		let environment = getEnvironmentFromUrl(window.location.toString(), window.location.search);
		window.history.replaceState(null, null, URLS[environment].product);
	} else if (action.type === actions.APP_IDENTITY_DENIED){
		store.remove('product');
		store.remove('token_data');
		store.remove('id_token');
		//store.set('token_data', null);
	} else if (action.type === actions.APP_SELECTED_PRODUCT) {
		store.set("product", action.payload);
	} else if (action.type === actions.APP_CLEARED_PRODUCT){
		store.remove('product');
	} else if (action.type === actions.FORM_UPDATE_SITECODE) {
		store.set('sitecode', action.payload);
	} else if (action.type === actions.APP_WARP) {
		store.set('devmode', true);
	} else if (action.type === actions.STARTING_UNITY_PLAYER_LOAD) {
		store.set('unity_player_load_start_timestamp', action.payload);
	}
	return next(action);
};

export default localStorageMiddleware(store);



// WEBPACK FOOTER //
// ./src/services/localStorageMiddleware.js